import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useSelector } from "react-redux";
import BasicMenu from "../UserHeader/HeaderdropDown";

const AuthHeader = () => {
  const { user } = useSelector((state) => state.auth)
  return (
    <>
      <header className="main-header">
        <div className="container-fluid p-0">
          <div className="header-row d-flex justify-content-between align-items-center">
            <div className="header-logo">
              <NavLink to="/">
                {" "}
                <img src="/assets/images/OHC-Logo.png" alt="" />{" "}
              </NavLink>
            </div>
            <div className="header-login">
              {user ? <BasicMenu /> : <ul className="list-unstyled">
                <li>
                  <NavLink to="/login" className="f-icon">
                    <FontAwesomeIcon icon={icon({ name: "user" })} />
                    LOGIN{" "}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/signup" className="f-icon">
                    {" "}

                    SIGNUP{" "}
                  </NavLink>
                </li>
              </ul>}

            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default AuthHeader